import React from 'react'
import * as R from 'ramda'

import { getInitState, getToggledState } from './utils.js'

export const useInternalState = ({ skillsArray }) => {
  const [reviewsOpenState, setReviewsOpenState] = React.useState(
    getInitState(skillsArray),
  )

  const allReviewsOpen = R.values(reviewsOpenState).every(open => open)

  const toggleAllReviews = () =>
    setReviewsOpenState(getToggledState(skillsArray, allReviewsOpen))

  const toggleReview = key => {
    setReviewsOpenState({ ...reviewsOpenState, [key]: !reviewsOpenState[key] })
  }

  return {
    state: {
      allReviewsOpen,
      reviewsOpenState,
    },
    handlers: {
      toggleAllReviews,
      toggleReview,
    },
  }
}
